// extracted by mini-css-extract-plugin
export default {"plain-button":"plainButton_plain-button__Sw9og","plain-button--compact":"plainButton_plain-button--compact__ul7E1"};